import { getEnvProperty, PROPERTIES } from "@app/core/services/environment-service"

export function getAwsErrorMessage(message: string): string {
  switch (message) {
    case "LimitExceededException":
      return "Tentative de réinitialisation dépassée, veuillez réessayer ultérieurement."
    case "InvalidParameterException":
      return `Votre email n'est pas vérifié. ${getEnvProperty(PROPERTIES.VITE_APP_BASE_URL)}/confirm`
    case "UserNotFoundException":
      return "Utilisateur non trouvé"
    case "ExpiredCodeException":
      return "Code expiré"
    case "CodeMismatchException":
      return "Code invalide"
    default:
      return message
  }
}
